import { useCallback } from 'react';
import { connect } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import { useIsEmbedded } from 'hooks/useIsEmbedded';

import { getMinTierNameForEditHistory } from 'selectors/session';

import GoToManagePlanPageButton from 'features/managePlan/components/GoToManagePlanPageButton';

import { toI18n } from 'util/i18n';
import { trackUxEvent } from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
} from 'util/tracking_constants';

const LIST_STYLE = { listStyle: 'disc' };
const LIST_ITEM_STYLE = { marginBottom: '8px' };

import { ValidTiersType } from 'features/managePlan/types';

import { cxHelpers } from 'util/className';
const { cx } = cxHelpers('EditHistoryPaywall');

export interface PaywallProps {
  tierName: ValidTiersType;
}

export const Paywall = ({ tierName }: PaywallProps) => {
  const isEmbedded = useIsEmbedded();

  const handleClickUpgrade = useCallback(
    () =>
      trackUxEvent({
        productArea: PRODUCT_AREAS.TIMESHEETS,
        eventCategory: EVENT_CATEGORIES.TIMECARD_DETAIL,
        eventAction: EVENT_ACTIONS.UPGRADE_BUTTON_FROM_EDIT_HISTORY_V3,
      }),
    []
  );

  return (
    <Box mt={20} className={cx()}>
      <Box mb={12}>
        <Text
          variant="heading4"
          color="mono900"
          i18n="timecard_modal.activity_paywall.title"
        />
      </Box>
      <Box ml={28}>
        <ul style={LIST_STYLE}>
          {toI18n('timecard_modal.activity_paywall.description').map(
            (item: string, key: number) => (
              <li style={LIST_ITEM_STYLE} key={key}>
                <Text>{item}</Text>
              </li>
            )
          )}
        </ul>
      </Box>
      <Box pv={24}>
        <GoToManagePlanPageButton
          fullWidth
          loadFullPage
          size="medium"
          theme={isEmbedded ? 'clover-green' : 'primary-purple'}
          onClick={handleClickUpgrade}
          i18nProps={{ tier_name: tierName }}
          i18n={
            isEmbedded
              ? 'manage_plans.title'
              : 'timecard_modal.activity_paywall.button'
          }
        />
      </Box>
    </Box>
  );
};

export default connect(state => ({
  tierName: getMinTierNameForEditHistory(state) as ValidTiersType,
}))(Paywall);
